"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Header.css");
var Header = function (_a) {
    var themeMode = _a.themeMode, currentTheme = _a.currentTheme, selectedMenu = _a.selectedMenu;
    var borderBottomColor = themeMode === "dark" ? "#151138" : "#E3E2E5";
    return (react_1.default.createElement("div", { role: "banner", className: "header-root", style: {
            background: currentTheme.header.mainBackground,
            color: currentTheme.header.textColor,
            // marginLeft: themeMode === "light" ? "-20px" : "0px",
            borderBottom: "1px solid ".concat(borderBottomColor),
        } },
        react_1.default.createElement("div", { className: "header-left", style: { fontSize: "2vh" } },
            selectedMenu === "Call And Process" ? "Home" : selectedMenu,
            react_1.default.createElement("hr", { className: "gradient-line" })),
        selectedMenu === "Call And Process" && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "header-left", style: { marginLeft: "2vh", marginRight: "2vh" } }, ">"),
            react_1.default.createElement("div", { className: "header-left", style: { color: "#8c8b9d" } }, selectedMenu)))));
};
exports.default = Header;
